import Vue from "vue"
import bugsnag from "@bugsnag/js"
import bugsnagVue from "@bugsnag/plugin-vue"

const errorLogger = {
  log(error, ...extra) {
    /* eslint-disable no-console */
    console.warn(`Caught by errorLogger:\n${error.message}`)
    console.error(error.stack)
    extra.forEach(console.log)
    /* eslint-enable no-console */
  }
}
if (process.env.VUE_APP_BUGSNAG_KEY) {
  // https://docs.bugsnag.com/platforms/browsers/vue/
  const bugsnagClient = bugsnag(process.env.VUE_APP_BUGSNAG_KEY)
  bugsnagClient.use(bugsnagVue, Vue)
  errorLogger.log = bugsnagClient.notify
}

export default errorLogger
